export const FETCH_ALL_DASHBOARD_VALUES = 'FETCH_ALL_DASHBOARD_VALUES'
export const FETCH_ALL_COMPLETED_APPLICATIONS = 'FETCH_ALL_COMPLETED_APPLICATIONS'
export const FETCH_ALL_REVIEWED_APPLICATIONS = 'FETCH_ALL_REVIEWED_APPLICATIONS'
export const FETCH_ALL_FILTERS = 'FETCH_ALL_FILTERS'
export const FETCH_ALL_EMAILS = 'FETCH_ALL_EMAILS'